import { SelfCareData } from '../../../data/selfcare/dashboard/selfcareData';
import { Observable, scan } from 'rxjs';
import { Injectable } from '@angular/core';
import { Upload, UtilityService } from '../..';
import { ApiConfig } from '../../../apiConfig';
import { BaseResponse, DataUsageStatistics, GetPaymentHistoryRequest, PaymentHistoryResponse, SimStatusResponse } from 'src/app/core/models';
import { HttpClient, HttpEvent, HttpEventType, HttpProgressEvent, HttpResponse } from '@angular/common/http';
import * as _ from 'lodash';

@Injectable()
export class SelfCareDashboardService extends SelfCareData {
  constructor(private utilityService: UtilityService, private http: HttpClient) {
    super();
  }
  changeCreditLimit(data: any): Observable<any> {
    return this.utilityService.postPut<any>(ApiConfig.selfcare.changeCreditLimit, data, null, 'post');
  }

  getBalanceInfoReports(): Observable<any> {
    return this.utilityService.postPut<any>(ApiConfig.selfcare.getBalanceInfoReports, null, null, 'post');
  }

  getBalanceInfoReportById(reportId: string): Observable<any> {
    return this.utilityService.postPut<any>(
      `${ApiConfig.selfcare.getBalanceInfoReportByID}?reportID=${reportId}`,
      null,
      null,
      'post',
    );
  }

  generateBalanceReport(msisdn: string): Observable<any> {
    return this.utilityService.postPut<any>(
      `${ApiConfig.selfcare.generateBalanceInfoReport}?msisdn=${msisdn}`,
      null,
      null,
      'post',
    );
  }

  getSubscriberInfo(data: any): Observable<any> {
    return this.utilityService.postPut<any>(ApiConfig.selfcare.getSubcriberInfo, data, null, 'post');
  }

  getOverdueBillsInfo(data: any): Observable<any> {
    return this.utilityService.postPut<any>(ApiConfig.selfcare.getOverDueBillInfo, data, null, 'post');
  }

  getDashboardGSMData(request: any): Observable<any> {
    return this.utilityService.postPut<any>(ApiConfig.selfcare.getDashboardGSMData, request, null, 'post');
  }

  getSecondaryMSISDNS(request: any): Observable<BaseResponse<any>> {
    return this.utilityService.postPut<any>(ApiConfig.selfcare.getSecondarMSIDNS, request, null, 'post');
  }

  getSecondaryMSISDNS2(request: any): Observable<BaseResponse<any>> {
    return this.utilityService.postPut<any>(ApiConfig.selfcare.getSecondarMSIDNS2, request, null, 'post');
  }

  enableDisableService(request: any): Observable<BaseResponse<any>> {
    return this.utilityService.postPut<any>(ApiConfig.selfcare.enableDisableService, request, null, 'post');
  }
  getCorporationAccountCodes(request: any): Observable<BaseResponse<any>> {
    return this.utilityService.postPut<any>(ApiConfig.selfcare.getCorporateAccountCodes, request, null, 'post');
  }

  uploadCampaignFile(files: File[], path?: string, smsBalance?: any): Observable<Upload> {
    var formData = new FormData();
    Array.from(files).forEach((file) => formData.append('file', file));
    formData.append('smsBalance', smsBalance);
    return this.http
      .post(ApiConfig.bulkSms.uploadCampaignFile, formData, {
        reportProgress: true,
        observe: 'events',
        responseType: 'json',
        headers: {
          filePath: path,
        },
      })
      .pipe(this.upload());
  }

  addNewCampaign(request: any): Observable<any> {
    return this.utilityService.postPut<any>(
      ApiConfig.bulkSms.addCampaign,
      request,
      null,
      'post',
    );
  }

  getAllCampaigns(request: any, isPriority?: boolean): Observable<any> {
  let url = `${ApiConfig.bulkSms.getAllCampaign}?customerId=${request}`;
  
  if (isPriority !== undefined) {
    url += `&isPriority=${isPriority}`;
  }
  
  return this.utilityService.postPut<any>(
    url,
    request,
    null,
    'post',
  );
}

  deleteBulkSMSBulk(id: number): Observable<any> {
    return this.utilityService.postPut<any>(
      `${ApiConfig.bulkSms.deleteCampaign}?campaignId=${id}`,
      null,
      null,
      'post',
    );
  }

  private upload(): (source: Observable<HttpEvent<unknown>>) => Observable<Upload> {
    return (source: Observable<HttpEvent<unknown>>) =>
      source.pipe(
        scan(
          (previous: Upload, event: HttpEvent<unknown>): Upload => {
            if (this.isHttpProgressEvent(event)) {
              return {
                progress: event.total ? Math.round((100 * event.loaded) / event.total) : previous.progress,
                state: 'IN_PROGRESS',
                content: null,
              };
            }
            if (this.isHttpResponse(event)) {
              return {
                progress: 100,
                state: 'DONE',
                content: event.body,
              };
            }
            return previous;
          },
          {
            state: 'PENDING',
            progress: 0,
            // content: new FileReceiverResult(),
            content: null,
          },
        ),
      );
  }

  private isHttpResponse<T>(event: HttpEvent<T>): event is HttpResponse<T> {
    return event.type === HttpEventType.Response;
  }

  private isHttpProgressEvent(event: HttpEvent<unknown>): event is HttpProgressEvent {
    return event.type === HttpEventType.DownloadProgress || event.type === HttpEventType.UploadProgress;
  }
  getAllSenderIdsConfig(): Observable<any> {
    return this.utilityService.postPut<any>(ApiConfig.selfcare.getAllSenderIdConfig, null, null, 'post');
  }

  getSalesAgentData(request: any): Observable<BaseResponse<any>> {
    return this.utilityService.postPut<any>(ApiConfig.selfcare.getSalesAgentDashboardData, request, null, 'post');
  }
  getCampaignById(campaignId: number): Observable<any> {
  return this.utilityService.get<any>(
    `${ApiConfig.bulkSms.getCampaignById}${campaignId}`,
    null,
    null,
    'get',
  );
}

editCampaign(request: any): Observable<any> {
  return this.utilityService.postPut<any>(
    ApiConfig.bulkSms.editCampaign,
    request,
    null,
    'post',
  );
}

  getSingleSmsStatus(campaignId: number): Observable<any> {
    const url = `${ApiConfig.bulkSms.getSingleSmsStatus}?campaignId=${campaignId}`;
    return this.http.get<any>(url);
  }

  retrySingleSms(campaignId: number): Observable<any> {
    const url = `${ApiConfig.bulkSms.retrySingleSms}?campaignId=${campaignId}`;
    return this.http.post<any>(url, {});
  }
  getEnterpriseSimStatuses(msisdn: string): Observable<BaseResponse<SimStatusResponse>> {
  return this.utilityService.postPut<SimStatusResponse>(
    ApiConfig.auth.getEnterpriseSimStatuses, 
    { msisdn }, 
    null, 
    'post'
  );
}
getEnterpriseSimDataUsageStatistics(msisdn: string): Observable<BaseResponse<DataUsageStatistics>> {
    return this.http.post<BaseResponse<DataUsageStatistics>>(
         ApiConfig.auth.getEnterpriseSimDataUsageStatistics,
        { Msisdn: msisdn }
    );
}
getPaymentHistory(request: GetPaymentHistoryRequest): Observable<BaseResponse<PaymentHistoryResponse>> {
  return this.http.post<BaseResponse<PaymentHistoryResponse>>(
     ApiConfig.auth.getPaymentHistroy,
    request
  );
}
}
